export default __webpack_public_path__ + "static/media/historyIcon.beb3d094.svg";